// The iban validator algorithm implements the algorithm detailed in:
// https://en.wikipedia.org/wiki/International_Bank_Account_Number
interface SupportedIban {
  [key: string]: { length: number };
}

const supportedIbans: SupportedIban = {
  PL: {
    length: 28,
  },
  RO: {
    length: 24,
  },
};

const modulo = (digits: string): boolean => {
  let currentIndex = 0;
  let currentGap = 9;
  let mod = '';
  do {
    const n = mod + digits.substring(currentIndex, currentIndex + currentGap);
    currentIndex += currentGap;
    currentGap = currentGap === 9 ? 7 : 9;
    mod = (parseInt(n, 10) % 97).toString();
  } while (currentIndex < digits.length - 1);
  return mod === '1';
};

const ibanValidator = (iban: string): boolean => {
  const sanitizedIban = iban.toUpperCase().replace(/\s/g, '');
  const countryCode = sanitizedIban.substring(0, 2);
  if (!supportedIbans[countryCode]) {
    return false;
  }
  if (supportedIbans[countryCode].length !== sanitizedIban.length) {
    return false;
  }

  const rearranged = sanitizedIban.slice(4) + sanitizedIban.substring(0, 4);
  let incorrectChars = false;
  const convertedToInteger = rearranged
    .split('')
    .map(char => {
      const charCode = char.charCodeAt(0);
      // A=65 Z=90
      if (charCode >= 65 && charCode <= 90) {
        return (charCode - 55).toString();
      }
      if (!/\d/.test(char)) {
        incorrectChars = true;
      }
      return char;
    })
    .join('');
  if (incorrectChars) {
    return false;
  }
  try {
    return modulo(convertedToInteger);
  } catch (err) {
    return false;
  }
};

export default ibanValidator;
